import React from 'react';
import { styled } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Colors } from 'library';
import { RBaseButton } from './RBaseButton';

interface RDashedAddButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    size?: 'sm' | 'md';
}

export function RDashedAddButton({ children, onClick, size = 'md' }: RDashedAddButtonProps) {
    return (
        <Button size={size} onClick={onClick}>
            <Add sx={{ fontSize: size === 'sm' ? 16 : 18, color: Colors.mediumGrey }} />
            {children}
        </Button>
    );
}

const Button = styled(RBaseButton)<{ size: 'sm' | 'md' }>(({ size }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: size === 'sm' ? '6px 12px' : '14px 16px',
    border: `1px dashed ${Colors.lightGrey}`,
    borderRadius: size === 'sm' ? 8 : 10,
    fontSize: size === 'sm' ? 13 : 14,
    fontWeight: 500,
    color: Colors.mediumGrey,
    alignSelf: 'flex-start',
    '&:hover': {
        borderColor: Colors.mediumGrey,
        backgroundColor: Colors.faintGrey,
    },
}));
